import { Box, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { throttle } from "lodash";
import { requestGoogleAuthVerify } from "@/pages/resetAccountInfo/api";
import { useI18n } from "@/hooks/useI18n";
import { BXButton, BXInput } from "@/styles";

const Ga = ({ requestId, onClose, onOk }) => {
  const { t } = useI18n();
  const codeRule = /^\d{6}$/;
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);
  const [codeText, setCodeText] = useState("");

  const checkCode = throttle(async () => {
    if (code) {
      const res = await requestGoogleAuthVerify({
        request_id: requestId,
        code: code,
      });
      if (res.code === 0) {
        onOk();
      }
    } else {
      setCodeError(true);
    }
  }, 5000);

  const codeChange = (e) => {
    const codeVal = e.target.value;
    if (codeVal) {
      setCodeError(false);

      if (codeRule.test(codeVal)) {
        setCode(codeVal);
        setCodeError(false);
      } else {
        setCodeText(t("yCCsuXAjuRzOLNxo"));
        setCodeError(true);
      }
    } else {
      setCodeText(t("LuigfaXzmPRCftdFOV"));
      setCodeError(true);
    }
  };

  return (
    <Flex
      justifyContent={"center"}
      w={"90%"}
      flexDirection={"column"}
      margin={"0 auto"}
    >
      <Text fontWeight={"600"} color="t.100" fontSize={25}>
        {t("sZVlKBQCGGTVChpa")}
      </Text>
      <Text
        fontSize="16px"
        fontWeight={"400"}
        color="t.100"
        mt="10px"
        mb="20px"
        textAlign={"left"}
      ></Text>
      <Text fontSize="16px" color="t.100">
        {t("OXrwZMwkWAjoSDDALzow")}
      </Text>
      <BXInput
        mt={"5px"}
        placeholder={t("cTlSqXgGENkCAQQJCHx")}
        className={codeError ? "error" : ""}
        isInvalid={codeError}
        onBlur={codeChange}
        w={"100%"}
      />
      {codeError && (
        <Text color="red.100" fontSize="12px" mt="5px">
          {codeText}
        </Text>
      )}
      <Box mt={"20px"}>
        <Flex justifyContent={"space-between"} mt={"30px"} w={"100%"}>
          <BXButton
            flex={"1"}
            className="cancel"
            onClick={() => {
              onClose();
            }}
          >
            {t("UNForxvjDLCZdGrmWkX")}
          </BXButton>
          <BXButton
            ml={"10px"}
            flex={"2.5"}
            onClick={() => {
              checkCode();
            }}
          >
            {t("tOaRBVUJHpnSgDBrGON")}
          </BXButton>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Ga;
